import { queryOptions } from "@tanstack/react-query";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { MediaLibraryPageInitialData } from "./mediaLibraryPageInitialData";
import { fetchOccPageData } from "./pageDataClient";

export const mediaLibraryPageSdsQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.sdsMediaLibrary(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<MediaLibraryPageInitialData>>("/page-data/sds-media-library"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
